import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const callLoginUser = data => post(URL.LOGIN_URL, data, {skipInterceptor: true});

export const sendLoginOtp = data => post(URL.SEND_LOGIN_OTP, data, {skipInterceptor: true});

export const verifyLoginOtp = data => post(URL.VERIFY_LOGIN_OTP, data, {skipInterceptor: true});